

const Button = ({ children, flush, ...rest }) => {



    return (
        <button {...rest} className={`${flush ? 'py-2.5' : 'py-2'} inline-flex text-center gap-1.5 justify-center items-center bg-emerald-300 border border-emerald-300 px-5 h-full rounded-lg text-sm leading-normal hover:shadow font-bold transition-all disabled:opacity-60`}>
            {children}
        </button>
    )
}

export default Button;